import { render, staticRenderFns } from "./course-select.vue?vue&type=template&id=5adb2dc8&scoped=true&"
import script from "./course-select.vue?vue&type=script&lang=js&"
export * from "./course-select.vue?vue&type=script&lang=js&"
import style0 from "./course-select.vue?vue&type=style&index=0&id=5adb2dc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adb2dc8",
  null
  
)

export default component.exports